import { TriggerLabel } from "../../../../../utils/constants";

enum SupportedProps {
  solutionId = "solutionId",
  solutionName = "solutionName",
  applicationId = "applicationId",
  applicationName = "applicationName",
  recordId = "recordId",
  recordTitle = "recordTitle",
  executionTimestamp = "executionTimestamp",
}

export const triggerProps: { [key: string]: SupportedProps[] } = {
  [TriggerLabel.createdRecord]: [
    SupportedProps.solutionId,
    SupportedProps.solutionName,
    SupportedProps.applicationId,
    SupportedProps.applicationName,
    SupportedProps.recordId,
    SupportedProps.recordTitle,
  ],
  [TriggerLabel.updatedRecord]: [
    SupportedProps.solutionId,
    SupportedProps.solutionName,
    SupportedProps.applicationId,
    SupportedProps.applicationName,
    SupportedProps.recordId,
    SupportedProps.recordTitle,
  ],
  [TriggerLabel.matchesCondition]: [
    SupportedProps.solutionId,
    SupportedProps.solutionName,
    SupportedProps.applicationId,
    SupportedProps.applicationName,
    SupportedProps.recordId,
    SupportedProps.recordTitle,
  ],
  [TriggerLabel.formSubmitted]: [
    SupportedProps.solutionId,
    SupportedProps.solutionName,
    SupportedProps.applicationId,
    SupportedProps.applicationName,
    SupportedProps.recordId,
    SupportedProps.recordTitle,
  ],
  [TriggerLabel.schedule]: [
    SupportedProps.solutionId,
    SupportedProps.solutionName,
    SupportedProps.applicationId,
    SupportedProps.executionTimestamp,
  ],
  [TriggerLabel.whenButtonIsClicked]: [
    SupportedProps.applicationId,
    SupportedProps.applicationName,
  ],
};
